import moment from "moment";
import { FC } from "react";
import MyCalendar from "./Calendar";
import ruRU from 'antd/es/calendar/locale/ru_RU';
import { Select, Row, Col } from "antd";

interface XCalendarProps {
  minDate: moment.Moment;
  maxDate: moment.Moment;
  selectedDate: moment.Moment;
  onSelectDate: (ev: any) => void;
  studio: any;
  width?: string;
  monthView?: string;
}

const XCalendar: FC<XCalendarProps> = ({
  studio, minDate, maxDate, selectedDate, onSelectDate, width = "", monthView = "select"
}) => {
  return (
    <MyCalendar
      validRange={[minDate, maxDate]}
      locale={ruRU}
      style={width === "" ? {} : { width }}
      defaultValue={selectedDate}
      value={selectedDate}
      onChange={(ev) => onSelectDate(ev)}
      headerRender={({ value, type, onChange, onTypeChange }) => {
        const currentYear = value.year();
        const month = value.month(); // 0-11
        const localeData = value.localeData();
        const months = Array.from({ length: 12 }, (_, i) => localeData.months(moment().month(i)));

        // Диапазон месяцев для выбранного года
        let startMonth = 0;
        let endMonth = 11;

        if (studio) {
          const monthsWithBookings = studio.booking
            .filter((item: any) => item.date_year === value.format("YYYY"))
            .map((item: any) => {
              // Парсим месяц из строки "01", "12" и т.п.
              return parseInt(item.date_month, 10) - 1; // moment months 0-11
            });

          if (monthsWithBookings.length > 0) {
            startMonth = Math.min(...monthsWithBookings);
            endMonth = Math.max(...monthsWithBookings);
          }
        }

        const monthOptions = [];
        for (let i = startMonth; i <= endMonth; i++) {
          monthOptions.push(
            <Select.Option key={i} value={i} className="month-item">
              {months[i]}
            </Select.Option>
          );
        }

        // Годы (±10 лет вокруг выбранного)
        const yearOptions = [];
        for (let y = currentYear - 10; y <= currentYear + 10; y++) {
          yearOptions.push(
            <Select.Option key={y} value={y} className="year-item">{y}</Select.Option>
          );
        }

        return (
          <div style={{ padding: "0 0 0 20px" }}>
            {monthView === "select" ? (
              <Row gutter={8}>
                <Col>
                  <Select
                    className="calendar_selector"
                    size="small"
                    popupMatchSelectWidth={false}
                    value={month}
                    onChange={(newMonth) => {
                      const newValue = value.clone().month(newMonth);
                      onChange(newValue);
                    }}
                  >
                    {monthOptions}
                  </Select>
                </Col>
                <Col>
                  <Select
                    className="calendar_selector"
                    size="small"
                    popupMatchSelectWidth={false}
                    value={currentYear}
                    onChange={(newYear) => {
                      const newValue = value.clone().year(newYear);
                      onChange(newValue);
                    }}
                  >
                    {yearOptions}
                  </Select>
                </Col>
              </Row>
            ) : (
              <div className="tabbed_months">
                {monthOptions.map((opt) => (
                  <div
                    key={opt.key}
                    className={`tm_item ${opt.key === month ? "selected" : ""}`}
                    onClick={() => onChange(value.clone().month(Number(opt.key)))}
                  >
                    {months[Number(opt.key)]}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      }}
    />
  );
};

export default XCalendar;
